import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})

export class JWTTokenService {

  jwtToken: string | any = '';

  helper = new JwtHelperService();
  decodedToken: any;

  constructor() {
  }

  setToken(token: string) {
    if (token) {
      this.jwtToken = token;
    }
  }

  decodeToken() {
    if (this.jwtToken) {
      this.decodedToken = this.helper.decodeToken(this.jwtToken);
    }
  }
  getDecodeToken() {
    this.decodeToken();
    return this.decodedToken;
  }

  getUser() {
    this.decodeToken();
    return this.decodedToken ? this.decodedToken['displayname'] : null;
  }

  getEmailId() {
    this.decodeToken();
    return this.decodedToken ? this.decodedToken['email'] : null;
  }

  getExpiryTime() {
    this.decodeToken();
    return this.decodedToken ? this.decodedToken['exp'] : null;
  }

  getPhoen() {
    this.decodeToken();
    return this.decodedToken ? this.decodedToken['phone'] : null;
  }

  isTokenExpired(): boolean {
    const expiryTime: number | any = this.getExpiryTime();
    if (expiryTime) {
      return ((1000 * expiryTime) - (new Date()).getTime()) < 5000;
    } else {
      return false;
    }
  }
}